module.exports = __webpack_public_path__ + "img/ai-compare-history-chevron-right.272f1199.svg";